import { handleActions } from 'redux-actions'

import { setDisplayAnswersMode, resetFormsState } from '../actions'
import { DisplayAnswersMode } from '../enums'

const defaultState: DisplayAnswersMode = DisplayAnswersMode.AllLatest

export default handleActions<DisplayAnswersMode, any>(
  {
    [setDisplayAnswersMode.toString()](state, action) {
      return action.payload
    },
    [resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
